const DEFAULT_KEY = '';
const DEFAULT_DURATION = 1000;
const MAP: Record<string, number> = {};

/**
 * Debounce by string key.
 * @param opts.key      Unique string for this “stream” of calls
 * @param opts.duration Window in ms (default: 1000)
 * @returns Promise<void> resolves if first-in-window, rejects if suppressed.
 */
export function debounceByKey(opts: { key?: string; duration?: number } = {}) {
  const { key = DEFAULT_KEY, duration = DEFAULT_DURATION } = opts;
  const now = Date.now();
  return new Promise<void>((resolve, reject) => {
    if (!MAP[key] || now > MAP[key]) {
      MAP[key] = now + duration;
      resolve();
    } else {
      reject(new Error(`debounce-by-key: '${key}' was debounced`));
    }
  });
}
